import React from "react";
import { Box, Typography } from "@mui/joy";
import { Fan, Shield } from "lucide-react";
import { FormSelect } from "../../../shared";

export function Equipment({ loading }: { loading?: boolean }) {
    return (
        <Box
        >
            <Box mb={2}>
                <Typography level="title-md">Equipment</Typography>
                <Typography level="body-sm" color="neutral">
                    Specify evaporative cooler and gutter guard details.
                </Typography>
            </Box>

            <Box
                sx={{
                    p: 2,
                    borderRadius: "4px",
                    border: "1px solid",
                    borderColor: "rgba(128, 128, 128, 0.2)",
                    bgcolor: "rgba(128, 128, 128, 0.05)",
                    backdropFilter: "blur(12px)",
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            sm: "repeat(2, 1fr)",
                            md: "repeat(2, 1fr)"
                        },
                        gap: 2.5,
                    }}
                >
                    <FormSelect
                        name="EvaporativeCooler"
                        label="Evaporative Cooler"
                        placeholder="Has evaporative cooler?"
                        helperText="Presence of an evaporative cooler."
                        disabled={loading}
                        startDecorator={<Fan size={16} />}
                        options={["No", "Yes"]}
                    />
                </Box>
            </Box>
        </Box>
    );
}
